import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "nexttime_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
  }
}

export async function api(path, { method = "GET", body, form } = {}) {
  try {
    const config = { url: path, method };
    if (form) {
      config.data = form;
    } else if (body !== undefined) {
      config.data = body;
      config.headers = { "Content-Type": "application/json" };
    }
    const res = await client.request(config);
    return res.data;
  } catch (e) {
    const data = e?.response?.data;
    const detail =
      (data && (data.detail || data.message)) ||
      (typeof data === "string" ? data : e.message || "Something went wrong");
    throw new ApiError(typeof detail === "string" ? detail : JSON.stringify(detail), e?.response?.status || 0);
  }
}
